/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { forwardRef, useState } from 'react';
import { NavLink as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  List, ListItem, Button, colors, Collapse, Typography,
} from '@material-ui/core';


import BatteryCharging60Icon from '@mui/icons-material/BatteryCharging60';


import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import NotificationsIcon from '@material-ui/icons/Notifications';
import EvStationIcon from '@material-ui/icons/EvStation';
import PowerIcon from '@material-ui/icons/Power';
import AddIcCallIcon from '@material-ui/icons/AddIcCall';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Textsms from '@material-ui/icons/Textsms';

import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import DockIcon from '@material-ui/icons/Dock';
import BusinessIcon from '@material-ui/icons/Business';
import SettingsIcon from '@material-ui/icons/Settings';
import QrCodeIcon from '@mui/icons-material/QrCode';

import { connect, useSelector } from 'react-redux';
// import { USER_AUTH } from 'common/constants';

import 'i18n/i18n';
import {useTranslation} from 'react-i18next';
import 'intl-pluralrules';


const CustomRouterLink = forwardRef((props, ref) => (
  <div ref={ref} style={{ flexGrow: 1 }}>
    <RouterLink {...props} />
  </div>
));



const SidebarNav = props => {

  const { /*pages,*/ className, user, simuSettings,...rest } = props;
  const classes = useStyles();

  const {t, i18n} = useTranslation();


  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const [openUsage, setOpenUsage] = useState(false);

  // const userAuth = useSelector((state) => state.user.user_auth);


  const handleClick = () => {
    setOpen(!open);
  }

  const handleClick2 = () => {
    setOpen2(!open2);
  }

  const handleUsage = () => {
    setOpenUsage(!openUsage);
  }

  return (
    <List className={clsx(classes.root, className)}>
      <ListItem className={classes.item} disableGutters key={'smartcharging'}>
        <Button activeClassName={classes.active} className={classes.button} component={CustomRouterLink} to={'/smartcharging'}>
          <div className={classes.icon}><EvStationIcon /></div>{i18n.t('smartcharging')}
        </Button>
      </ListItem>

      <ListItem className={classes.item} disableGutters key={'QRCodeInput'}>
        <Button activeClassName={classes.active} className={classes.button} component={CustomRouterLink} to={'/qrcodeinput'}>
          <div className={classes.icon}><QrCodeIcon /></div>{i18n.t('QRCodeInput')}
        </Button>
      </ListItem>

      <ListItem className={classes.item} disableGutters key={'QRCode_samples'}>
        <Button activeClassName={classes.active} className={classes.button} component={CustomRouterLink} to={'/qrcodesamples'}>
          <div className={classes.icon}><QrCodeIcon /></div>{i18n.t('QRCodeSamples')}
        </Button>
      </ListItem>


      <ListItem className={classes.item} disableGutters key={'QRCodeMalaysia'}>
        <Button activeClassName={classes.active} className={classes.button} component={CustomRouterLink} to={'/qrcodesMalaysia'}>
          <div className={classes.icon}><QrCodeIcon /></div>{i18n.t('QRCodeMalaysia')}
        </Button>
      </ListItem>


      <ListItem disabled={true}  className={classes.item} disableGutters key={'smartdischarge'}>
        <Button activeClassName={classes.active} className={classes.button} component={CustomRouterLink} /*to={'/smartdischarging'}*/>
          <div className={classes.icon}><BatteryCharging60Icon /></div>{i18n.t('smartdischarge')}
        </Button>
      </ListItem>

      <ListItem disabled={true}  className={classes.item} disableGutters key={'chgr. Mng'}>
        <Button activeClassName={classes.active} className={classes.button} component={CustomRouterLink} /*to={'/chargers'}*/>
          <div className={classes.icon}><DockIcon /></div>{i18n.t('chgrMng')}
        </Button>
      </ListItem>

      <ListItem disabled={true} className={classes.item} disableGutters key={'settings'}>
        <Button activeClassName={classes.active} className={classes.button} onClick={handleClick2} >
          <div className={classes.icon}><SettingsIcon /></div>{i18n.t('settings')}
        </Button>
        {open2 ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open2} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem className={classes.sub_item} key={'chgr. model'}>
            <Button disabled={true} activeClassName={classes.active} className={classes.button}
              component={CustomRouterLink} /*to={'/settings/chargermodel'}*/>
              <div className={classes.icon}><ArrowRightIcon /></div>{i18n.t('chargerModel')}
            </Button>
          </ListItem>
        </List>
      </Collapse>


      <ListItem className={classes.item} disableGutters key={'command'}>
        <Button disabled={true} activeClassName={classes.active} className={classes.button} component={CustomRouterLink} /*to={'/command'}*/>
          <div className={classes.icon}><Textsms /></div>{i18n.t('ocppCommand')}
        </Button>
      </ListItem>

    </List>

  );
};

SidebarNav.propTypes = {
  className: PropTypes.string,
  // pages: PropTypes.array.isRequired
};



let mapStateToProps = (state) => {
  return {
    user: state.user,
  };
}


export default connect(mapStateToProps)(SidebarNav);
// export default SidebarNav;


const useStyles = makeStyles(theme => ({
  root: {},
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 10,
  },
  sub_item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0,
    paddingLeft: 26,
  },
  button: {
    // color: colors.blueGrey[800],
    color: "#2a3f54",
    padding: '10px 8px',
    justifyContent: 'flex-start',
    textTransform: 'none',
    letterSpacing: 0,
    width: '100%',
    fontWeight: theme.typography.fontWeightMedium
  },
  icon: {
    color: theme.palette.icon,
    // color: "#2a3f54",
    width: 24,
    height: 24,
    display: 'flex',
    alignItems: 'center',
    marginRight: theme.spacing(1)
  },
  active: {
    color: theme.palette.primary.main,
    // color: "#000000",
    // backgroundColor: "#b7b7b7",
    fontWeight: theme.typography.fontWeightMedium,
    '& $icon': {
      color: theme.palette.primary.main
      // color: "#000000"
    }
  }
}));